import { useGlobalHandlers } from "@/composables/useGlobalHandlers";
import { goSolidApi } from "@/composables/useGoSolidApi";
import { onMounted, ref } from "vue";
import type { BulkBuyFormOptions } from "./bulkBuyTypes";

export function useBulkBuyOptions() {
  const { globalErrorHandler } = useGlobalHandlers();
  const options = ref<BulkBuyFormOptions | null>(null);

  const fetchOptions = async () => {
    try {
      const response = await goSolidApi.get<BulkBuyFormOptions>(
        "/api/eac/buy-and-cancel/form-options"
      );
      options.value = response.data;
    } catch (err) {
      globalErrorHandler(err);
    }
  };

  onMounted(() => {
    fetchOptions();
  });

  return { options };
}
